import Model from 'core/model/Model';

export default class RouteDestinationModel extends Model {}
